(()=>{
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='1';
    const data=JSON.parse(root.querySelector('[data-bvv-data]').textContent);
    const liveNode=root.querySelector('[data-bvv-live]');
    const live=liveNode?JSON.parse(liveNode.textContent):null;
    const family=root.querySelector('[data-bvv-family]'),size=root.querySelector('[data-bvv-size]');
    const img=root.querySelector('[data-bvv-image]'),roomImg=root.querySelector('[data-bvv-room]');
    const stage=root.querySelector('[data-bvv-stage]'),button=root.querySelector('[data-bvv-submit]'),id=root.querySelector('[data-bvv-id]');
    const views=[...root.querySelectorAll('[data-bvv-view]')];
    const variants=live?live.map(v=>({id:String(v.id),a:v.option1,s:v.option2,price:v.price,available:v.available})):data.variants;
    const requested=new URL(location.href).searchParams.get('variant'),initial=variants.find(v=>v.id===requested);
    let selectedView=0;
    if(initial){family.value=initial.a;size.value=initial.s}
    function sized(url,width){const u=new URL(url);u.searchParams.set('width',width);return u.href}
    function gallery(){
      const art=data.art.find(a=>a.label===family.value);
      if(!art)return;
      const room=selectedView?data.rooms[selectedView-1]:null;
      stage.className='bvv-stage'+(room?' bvv-scene-'+room.name:'');
      roomImg.hidden=!room;
      if(room){const src=sized(room.url,1600);if(roomImg.src!==src)roomImg.src=src;}
      const src=sized(art.url,1600);if(img.src!==src)img.src=src;
      const label=views[selectedView].innerText.trim();
      img.alt='De Brug van Verbondenheid — '+art.label+(room?' — '+label:'');
      root.querySelector('[data-bvv-caption]').textContent=art.label+(room?' · '+label:'');
      root.querySelector('[data-bvv-scene-note]').hidden=!room;
      root.querySelectorAll('[data-bvv-thumb-art]').forEach(thumb=>{const src=sized(art.url,240);if(thumb.src!==src)thumb.src=src});
      views.forEach((view,i)=>view.setAttribute('aria-pressed',String(i===selectedView)));
    }
    function update(){
      gallery();
      const v=variants.find(v=>v.a===family.value&&v.s===size.value);
      id.value=v?v.id:'';
      root.querySelector('[data-bvv-price]').textContent=v?new Intl.NumberFormat(document.documentElement.lang||'nl-BE',{style:'currency',currency:'EUR'}).format(v.price/100):'—';
      button.disabled=!(root.dataset.live==='true'&&v&&v.available);
      const selection=family.value+' / '+size.value;
      root.querySelector('[data-bvv-custom]').href='https://wa.me/32492479493?text='+encodeURIComponent('Hallo Jan, ik heb een vraag over een aanpassing van De Brug van Verbondenheid. Mijn keuze: '+selection);
      root.querySelector('[data-bvv-visual]').href='https://wa.me/32492479493?text='+encodeURIComponent('Hallo Jan, ik ontvang graag een gratis interieurvisualisatie van De Brug van Verbondenheid. Mijn keuze: '+selection+'. Ik stuur een foto en de afmetingen mee.');
      if(root.dataset.live==='true'&&v){const url=new URL(location.href);url.searchParams.set('variant',v.id);if(root.dataset.previewTheme)url.searchParams.set('preview_theme_id',root.dataset.previewTheme);history.replaceState(null,'',url)}
    }
    views.forEach((view,i)=>view.addEventListener('click',()=>{selectedView=i;gallery()}));
    family.addEventListener('change',update);size.addEventListener('change',update);
    root.querySelector('form').addEventListener('submit',e=>{if(button.disabled||!id.value)e.preventDefault()});
    update();
  }
  document.querySelectorAll('[data-bvv]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-bvv]').forEach(init));
})();
